var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "14 12 92 94",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#06B6D4;} .st1{fill:#3DB2FF;} .st2{fill:#FFFFFF;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.9,92.2c4.8-5.4,7.5-12.8,7-20.8c-0.7-9.8-6.6-18.3-14.9-22.7c0,0.8,0,1.6,0,2.5 c-0.8,18.9-16.3,34.9-35.3,36.4c-0.7,0-1.4,0.1-2.1,0.1c4.6,7.7,12.7,13.1,22,13.8c3.9,0.2,7.7-0.2,11.3-1.4 c1.8-0.6,8.9,2.8,12.9,4.9c1,0.5,2.2-0.5,1.7-1.6C98,99.6,96,93.3,96.9,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2,51c-0.8,17.2-14.7,31.5-31.8,32.8c-4.8,0.3-9.5-0.3-13.9-1.7c-2.3-0.8-10.9,3.5-15.9,6.1 c-1.2,0.6-2.7-0.6-2.1-2c1.8-4.8,4.4-12.6,3.2-13.9c-5.9-6.7-9.2-15.7-8.6-25.6c1.2-17.2,15.6-31.2,32.8-31.9 C69.3,13.8,86.1,30.6,85.2,51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,57.3h-2.7c-0.8,0-1.5-0.7-1.5-1.5c0,0,0,0,0,0c0-1.8,0.3-3.3,0.9-4.5s1.8-2.5,3.6-3.9 c1.8-1.5,2.9-2.4,3.2-2.9c0.5-0.7,0.8-1.5,0.8-2.4c0-1.2-0.5-2.2-1.4-3.1c-1-0.9-2.2-1.3-3.9-1.3c-1.6,0-2.9,0.4-3.9,1.3 c-0.6,0.5-1.1,1.2-1.5,2c-0.5,1.2-1.7,1.9-3,1.8h0c-2-0.3-3.2-2.5-2.2-4.3c0.5-1,1.3-1.9,2.2-2.8c2.1-1.8,4.8-2.7,8.1-2.7 c3.5,0,6.3,0.9,8.4,2.8c2.1,1.8,3.1,4,3.1,6.4c0,1.4-0.4,2.6-1.1,3.8s-2.4,2.9-4.9,4.9c-1.3,1.1-2.1,1.9-2.4,2.6 c-0.2,0.5-0.4,1.2-0.4,2.2C52.8,56.7,52.2,57.3,51.4,57.3z M47.3,62.6v-0.3c0-1.6,1.3-2.9,2.9-2.9h0.3c1.6,0,2.9,1.3,2.9,2.9v0.3 c0,1.6-1.3,2.9-2.9,2.9h-0.3C48.6,65.5,47.3,64.2,47.3,62.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback1);
export default __webpack_public_path__ + "static/media/feedback1.c95cea4786f2567f31212438fa7f881f.svg";
export { ForwardRef as ReactComponent };